// Keys align with TAG_TITLES in ./TagIcons.js
import IconChina from "../Assets/images/nationality/china.svg";
import IconIndonesia from "../Assets/images/nationality/indonesian.svg";
import IconMalaysia from "../Assets/images/nationality/malaysian.svg";
import IconSingapore from "../Assets/images/nationality/singapore.svg";
import IconThai from "../Assets/images/nationality/thai.svg";
import IconMale from "../Assets/images/gender/male.svg";
import IconFemale from "../Assets/images/gender/female.svg";
import IconRequested from "../Assets/images/requested.svg";
import IconNotes from "../Assets/images/notes.svg";
import IconCustomer from "../Assets/images/customer-app.svg";
import IconRoom from "../Assets/images/room.svg";
import IconNatal from "../Assets/images/natal.svg";
import IconSlimming from "../Assets/images/slimming.svg";
import IconRepeatBooking from "../Assets/images/repeating_booking.svg";
import IconWebNotes from "../Assets/images/web-notes.svg";

export const BOOKING_TAG_ICONS = {
  isRequested: IconRequested,
  bookingThrough: IconCustomer,
  hasRequestedRoom: IconRoom,
  natal: IconNatal,
  slimming: IconSlimming,
  repeat: IconRepeatBooking,
  haveNotes: IconNotes,
  hasWebNotes: IconWebNotes,
  China: IconChina,
  thai: IconThai,
  malaysian: IconMalaysia,
  singapore: IconSingapore,
  indonesian: IconIndonesia,
  male: IconMale,
  female: IconFemale,
};
